import { Permission } from '@customer/permissions';
import { HelpCardData } from './help-card/HelpCard';
import { ExternalUrl, Permalink } from '@cas/config/links';

const HELP_CARD_DOCUMENTATION: HelpCardData = {
  title: 'Documentation',
  description: 'DocumentationDescription',
  links: [
    {
      url: '/techlibrary',
      value: 'TechnicalLibrary',
    },
    {
      url: Permalink.ProductDocumentation,
      value: 'ProductDocumentation',
      isExternal: true,
    },
  ],
  permission: Permission.CanAccess,
};

const HELP_CARD_SUPPORT: HelpCardData = {
  title: 'Support',
  description: 'SupportDescription',
  links: [
    {
      url: Permalink.KnowledgeBase,
      value: 'KnowledgeBase',
      isExternal: true,
    },
    {
      url: Permalink.SupportRequest,
      value: 'SupportRequest',
      isExternal: true,
    },
  ],
  permission: Permission.Anonymous,
};

const HELP_CARD_FEEDBACK: HelpCardData = {
  title: 'Feedback',
  description: 'FeedbackDescription',
  links: [
    {
      url: Permalink.SubmitFeedback,
      value: 'SubmitFeedback',
      isExternal: true,
    },
  ],
  permission: Permission.CanAccess,
};

const HELP_CARD_LINKS: HelpCardData = {
  title: 'Links',
  description: null,
  links: [
    {
      url: ExternalUrl.PrivacyPolicy,
      value: 'PrivacyPolicy',
      isExternal: true,
    },
    {
      url: ExternalUrl.MiningContact,
      value: 'ContactUs',
      isExternal: true,
    },
  ],
  permission: Permission.Anonymous,
};

export const HELP_CARDS: HelpCardData[] = [
  HELP_CARD_DOCUMENTATION,
  HELP_CARD_SUPPORT,
  HELP_CARD_FEEDBACK,
  HELP_CARD_LINKS,
];
